// removed by extract-text-webpack-plugin
module.exports = {"fontFamilyLato":"\"Lato\",sans-serif","colorWhite":"#fff","colorBorderGray":"#d9d9d9","colorGreen":"#1d9e39","colorRed":"red"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Timeline/Timeline.scss
// module id = 1236
// module chunks = 0